// Helper function to hash password
const hashPassword = async (password) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

const fetchLoginDetails = async () => {
  const url = 'https://go-gin-certificate-portal.onrender.com/loginCredentials';
//   const url = 'http://localhost:8080/loginCredentials';

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();

    if (
      !result ||
      !Array.isArray(result.data) ||
      result.data.length < 2
    ) {
      throw new Error('Invalid API response format');
    }

    // API returns plain password, so we hash it for storage
    const passwordHash = await hashPassword(result.data[1]);

    return {
      username: result.data[0],
      passwordHash: passwordHash
    };
  } catch (error) {
    console.error('Error fetching login details:', error);
    return null;
  }
};

export default fetchLoginDetails;
